<template>
  <el-form
    class="login-form"
    status-icon
    :rules="loginRules"
    ref="loginForm"
    :model="loginForm"
    label-width="0"
  >
    <div class="title">登录</div>
    <el-form-item v-if="tenantMode" prop="tenantId">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        v-model="loginForm.tenantId"
        auto-complete="off"
        :placeholder="$t('login.tenantId')"
      >
        <i slot="prefix" class="icon-quanxian" />
      </el-input>
    </el-form-item>
    <!--  -->
    <el-form-item prop="username">
      <!-- <el-input
        size="small"
        id="username_123"
        @keyup.enter.native="handleLogin"
        v-model="loginForm.username"
        auto-complete="off"
        :placeholder="$t('login.username')"
      </el-input> -->
      <div class="input">
        <img src="/img/username.png" class="input-icon">
      <input  v-model="loginForm.username" @keyup.enter.native="handleLogin" type="text">
      <div class="showpass"></div>
      </div>
    </el-form-item>
    <!--  -->
    <el-form-item prop="password">
      <!-- <el-input
        id="password_123"
        size="small"
        @keyup.enter.native="handleLogin"
        :type="passwordType"
        v-model="loginForm.password"
        auto-complete="off"
        :placeholder="$t('login.password')"
      >
        <i
          class="el-icon-view el-input__icon"
          slot="suffix"
          @click="showPassword"
        />
        <i slot="prefix" class="icon-mima" />
      </el-input> -->
       <div class="input">
        <img src="/img/password.png" class="input-icon">
      <input  v-model="loginForm.password" @keyup.enter.native="handleLogin" :type="passwordType">
      <img  class="showpass" src="/img/eye.png" alt="" @click="showPassword">
      </div>
    </el-form-item>
    <el-form-item v-if="this.website.captchaMode" prop="code">
      <el-row :span="24">
        <el-col :span="16">
          <el-input
            size="small"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.code"
            auto-complete="off"
            :placeholder="$t('login.code')"
          >
            <i slot="prefix" class="icon-yanzhengma" />
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <img
              :src="loginForm.image"
              class="login-code-img"
              @click="refreshCode"
            />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <button
        type="primary"
        size="small"
        color="#F99D35"
        @click.native.prevent="handleLogin"
        class="login-submit"
        >{{ $t("login.submit") }}
      </button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import { info } from "@/api/system/tenant";
import { getCaptcha } from "@/api/user";
import { getTopUrl } from "@/util/util";
import urlSettings from '@/config/url-settings.js';
export default {
  name: "userlogin",
  data() {
    return {
      tenantMode: this.website.tenantMode,
      loginForm: {
        //租户ID
        tenantId: "",
        //用户名
        username: "admin",
        //密码
        password: "admin",
        //账号类型
        type: "account",
        //验证码的值
        code: "",
        //验证码的索引
        key: "",
        //预加载白色背景
        image:
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      },
      loginRules: {
        tenantId: [
          { required: false, message: "请输入租户ID", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 1, message: "密码长度最少为6位", trigger: "blur" },
        ],
      },
      passwordType: "password",
    };
  },
  created() {

  },
  mounted() {this.getTenant();
    this.refreshCode();},
  computed: {
    ...mapGetters(["tagWel"]),
  },
  props: [],
  methods: {
    refreshCode() {
      getCaptcha().then((res) => {
        const data = res.data;
        this.loginForm.key = data.key;
        this.loginForm.image = data.image;
      });
    },
    showPassword() {
      this.passwordType === ""
        ? (this.passwordType = "password")
        : (this.passwordType = "");
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "登录中,请稍后。。。",
            spinner: "el-icon-loading",
          });
          this.$store
            .dispatch("LoginByUsername", this.loginForm)
            .then(() => {
              this.$router.push({ path: this.tagWel.value });
              loading.close();
            })
            .catch(() => {
              loading.close();
              this.refreshCode();
            });
        }
      });
    },
    getTenant() {
      let domain = getTopUrl();
      if(urlSettings.TENANTID){
        this.tenantMode = false;
        this.loginForm.tenantId = urlSettings.TENANTID;
        this.$parent.$refs.login.style.backgroundImage = urlSettings.BACKGROUND;
      }else{
        this.$message.error(`该域名【${domain}】未配置，请尽快联系管理员！`);
      }
      // 临时指定域名，方便测试

    },
  },
};
</script>

<style lang='scss' scoped>
.login-form {
  padding: 55px 55px 0;
}
.title {
  text-align: center;
  color: #f99d35;
  font-size: 22px;
  letter-spacing: 5px;
  margin-bottom: 10px;
}
.input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #6D5B55;
  padding: 0 10px;
  margin:10px 0;
  input {
    width: 80%;
    border: none;
    height: 50px;
    color: #6D5B55;
    font-size: 16px;
  }
  input::placeholder {
    color: #6D5B55;
    height: 50px;
    line-height: 50px;
  }
  .input-icon{
    width: 16px;
    height: 18px;
  }
}
.showpass{
  width: 20px;
  height: 14px;
}
#password_123 {
  border: none;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #ccc;
  margin:10px 0
}
.login-submit{
  width: 100%;
  border: 1px solid #f99d35;
  color: #f99d35;
  background-color: #fff;
  height: 40px;
  border-radius: 2px;
  margin-bottom: 50px;
}
</style>
